import { object, string, number } from 'yup';

export const createAssetSchema = object({
    vehicleGroup: string()
        .required()
        .required('Transportation mode is required'),
    type: string().required('Vehicle type is required'),
    make: string().required('Make is required'),
    model: string().required('Model is required'),
    licensePlate: string().required('License plate is required'),
    year: number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .required('Year is required'),
    mileageStart: number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .required('Mileage start is required'),
    maxPassengers: number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .required('Max passengers is required'),
    fuelType: string().required('Fuel type is required'),
});
